<template>
  <a-card :title="params.formTitle">
    <div class="formContainer">
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item label="父节点" :label-col="{ span: 6}" :wrapper-col="{ span: 12}">
          <a-input
            disabled
            v-decorator="['pName']"
            autocomplete="off"/>
        </a-form-item>
        <a-form-item label="名称" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" hasFeedback>
          <a-input
            autocomplete="off"
            v-decorator="['name', { rules: [{ required: true, message: '请输入名称！'},{pattern: /^[^\s]*$/, message: '名称不能包含空格！' },{max:50,message:'最多输入50个字'}] }]" />
        </a-form-item>
        <a-form-item label="编码" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" hasFeedback>
          <a-input
            autocomplete="off"
            :disabled="this.dictList.id!=null"
            v-decorator="['code', { rules: [{ required: true, message: '请输入编码!' },{pattern: /^[^\s]*$/, message: '编码不能包含空格！' },{max:50,message:'最多输入50个字'}] }]" />
        </a-form-item>
        <a-form-item label="字典值" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input
            autocomplete="off"
            v-decorator="['value',{ rules: [{ required: false, message: '请输入字典值！' }, {pattern: /^[^\s]*$/, message: '字典值不能包含空格！' }, {max:50,message:'最多输入50个字'}] }]" />
        </a-form-item>
        <a-form-item label="备注" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-textarea
            v-decorator="['remark',{ rules: [{ required: false, message: '请输入备注！' }, {pattern: /^[^\s]*$/, message: '备注不能包含空格！' }, {max:225,message:'最多输入225个字'}] }]"
            :rows="4" />
        </a-form-item>
        <a-row>
          <a-col :span="24" :pull="6" :style="{ textAlign: 'right' }">
            <a-button v-if="(params.formTitle==='新建字典'&&$auth('dict.add'))||(params.formTitle==='编辑字典'&&$auth('dict.update'))" @click="handleCancel" :style="{ marginRight: '8px'}">取消</a-button>
            <a-button type="primary" v-if="(params.formTitle==='新建字典'&&$auth('dict.add'))||(params.formTitle==='编辑字典'&&$auth('dict.update'))" html-type="submit" :loading="iconLoading">保存</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { editDictInfo, createDictInfo } from '@/api/dict.js'

export default {
  data () {
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      iconLoading: false
    }
  },
  props: {
    params: {
      type: Object,
      default: function () {
        return {
          formTitle: ''
        }
      }
    }
  },
  computed: mapGetters(['dictList']),
  watch: {
    dictList () {
      console.log('改变', this.dictList)
      console.log('当前字典的sort值', this.dictList.sort)
      // 如果为空,重置表单
      if (Object.keys(this.dictList).length !== 0) {
        this.form.setFieldsValue({
          pName: this.dictList.pName,
          name: this.dictList.name,
          code: this.dictList.code,
          value: this.dictList.value,
          remark: this.dictList.remark
        })
      } else {
        this.form.resetFields()
      }
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.iconLoading = true
          const arg = {
            pid: this.dictList.pid,
            name: values.name,
            code: values.code,
            value: values.value,
            remark: values.remark
          }
          if (this.dictList.id != null) {
            arg.id = this.dictList.id
            this.editDict(arg)
          } else {
            this.addDict(arg)
          }
        }
      })
    },
    // 取消
    handleCancel (e) {
      e.preventDefault()
      if (Object.keys(this.dictList).length !== 0) {
        this.form.setFieldsValue({
          pName: this.dictList.pName,
          name: this.dictList.name,
          code: this.dictList.code,
          value: this.dictList.value,
          remark: this.dictList.remark
        })
      } else {
        this.form.resetFields()
      }
    },
    // 编辑字典
    editDict (info) {
      editDictInfo(info).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message, 3)
          this.iconLoading = false
          // 完成提交后,向父组件传递事件
          this.$emit('submitEvent')
        } else {
          this.$message.error(res.info.message, 3)
          this.iconLoading = false
        }
      })
    },
    // 新建字典
    addDict (info) {
      createDictInfo(info).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message, 3)
          this.iconLoading = false
          // 完成提交后,向父组件传递事件
          this.$emit('submitEvent')
          this.dictList.id = res.data
          this.params.formTitle = '编辑字典'
        } else {
          this.$message.error(res.info.message, 3)
          this.iconLoading = false
        }
      })
    }
  }
}
</script>
<style>
  .formContainer{
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-item:center;
  }
</style>
